import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const API_BASE = 'userpreferences/v1/permissions';
export default class ProfileAPI {
  static getCurrentUserPermissions() {
    return http.get(API_BASE, {
      portalId: PortalIdParser.get()
    });
  }
}